import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EquisButtonModule } from '@tn-equis/core/components/button';
import { EquisDrawerModule } from '@tn-equis/core/components/drawer';
import { EquisDropdownModule } from '@tn-equis/core/components/dropdown';
import { SearchbarComponent } from './searchbar/searchbar.component';
import { PipeModule } from '../pipes/pipes.module';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { EquisBreadcrumbModule } from '@tn-equis/core/components/breadcrumb';
import { EquisTextfieldModule } from '@tn-equis/core/components/textfield';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import FooterModule from './footer/footer.module';
import NavbarModule from './navbar/navbar.module';
import AppMobileNavBarModule from './appmobile-navbar/appmobile-navbar.module';

@NgModule({
  declarations: [SearchbarComponent, BreadcrumbComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    NavbarModule,
    AppMobileNavBarModule,
    FooterModule,
    PipeModule,
    TranslateModule,
    EquisButtonModule,
    EquisBreadcrumbModule,
    EquisDrawerModule,
    EquisDropdownModule,
    EquisTextfieldModule,
  ],
  exports: [
    SearchbarComponent,
    BreadcrumbComponent,
    NavbarModule,
    AppMobileNavBarModule,
    FooterModule,
  ],
})
export class ComponentsModule {}
